import React from "react";

interface HighRiskSpaceProps {
  height?: number;
}

export const HighRiskSpace: React.FC<HighRiskSpaceProps> = ({
  height = 32,
}) => (
  <svg
    className="high-risk-space"
    preserveAspectRatio="none"
    viewBox={`0 0 450 ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    height={height}
  >
    <path
      d={`M0 0H446C448.209 0 450 1.79086 450 4V${height - 4}C450 ${
        height - 1.79086
      } 448.209 ${height} 446 ${height}H0V0Z`}
      fill="url(#paint0_linear_1016_1699)"
      fillOpacity="0.8"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1016_1699"
        x1="0"
        y1={height / 2}
        x2="450"
        y2={height / 2}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFD92" />
        <stop offset="0.0384615" stopColor="#FCCE17" />
        <stop offset="0.516643" stopColor="#D90C20" />
        <stop offset="1" stopColor="#42105F" />
      </linearGradient>
    </defs>
  </svg>
);
